// A 413 (or the pre-check) must reach useSmartDraftManager as a distinguishable result, never
// as `null`: retrying a request that can never succeed would loop forever.
export interface PayloadTooLargeResult {
  isPayloadTooLarge: true;
}

export const PAYLOAD_TOO_LARGE_RESULT: PayloadTooLargeResult = {
  isPayloadTooLarge: true,
};

export const isPayloadTooLargeResult = (
  value: unknown,
): value is PayloadTooLargeResult =>
  Boolean(value) &&
  typeof value === 'object' &&
  (value as Partial<PayloadTooLargeResult>).isPayloadTooLarge === true;
